<template>
  <div>
    <div>
      <div class="writeGridContainer" style="width: 66.66%">
        <div class="col-span-6">
          <div>위험도</div>
          <div>
            <div class="print-input">{{ risk }}</div>
          </div>
        </div>
        <div class="col-span-6">
          <div>중요위험</div>
          <div class="print-input">{{ importantRisk }}</div>
        </div>
      </div>
    </div>
    <table>
      <colgroup>
<!--        개정전-->
        <template v-if="!isRevision">
          <col /><col /><col /><col />
          <col width="83"/><col width="83"/><col width="83"/><col />
          <col /><col /><col width="83"/><col width="83"/>
          <col v-if="!isDKRAS"/>
        </template>
<!--        개정후-->
        <template v-else>
          <col /><col /><col /><col />
          <col width="83"/><col width="83"/><col width="83"/><col />
          <col /><col /><col /><col />
          <col /><col /><col width="83"/><col width="83"/>
          <col v-if="!isDKRAS"/>
        </template>
      </colgroup>
      <thead>
<!--      개정전-->
      <template v-if="!isRevision">
        <tr>
          <template v-for="(table, tableIndex) in tableData">
            <th v-if="tableIndex === 4" colspan="3">현재 위험도</th>
            <th v-else-if="tableIndex === 10" colspan="2">적합성검토</th>
            <th v-else-if="tableIndex !== 5 && tableIndex !== 6 && tableIndex !== 11" rowspan="2">{{ table.title }}</th>
          </template>
        </tr>
        <tr>
          <th>발생빈도</th>
          <th>위험강도</th>
          <th>단위위험</th>
          <th>1차</th>
          <th>2차</th>
        </tr>
      </template>
<!--      개정후-->
      <template v-else>
        <tr>
          <template v-if="isDKRAS">
            <th rowspan="2">분류</th>
            <th rowspan="2">원인</th>
            <th rowspan="2">위험요인</th>
            <th rowspan="2">현재조치 관리상태</th>
            <th rowspan="1" colspan="3">현재 위험도</th>
            <th rowspan="2">감소대책</th>
            <th rowspan="1" colspan="3">개선후 위험도</th>
            <th rowspan="2">개선결과</th>
            <th rowspan="2">담당자</th>
            <th rowspan="2">완료일(예정일)</th>
            <th rowspan="1" colspan="2">적합성검토</th>
          </template>
          <template v-else>
            <tr>
              <th rowspan="2">작업단계</th>
              <th rowspan="2">작업사진</th>
              <th rowspan="2">위험요인</th>
              <th rowspan="2">현재관리상태</th>
              <th rowspan="1" colspan="3">현재 위험도</th>
              <th rowspan="2">감소대책</th>
              <th rowspan="2">담당자</th>
              <th rowspan="2">완료일(예정일)</th>
              <th rowspan="1" colspan="2">적합성검토</th>
              <th rowspan="2">비고</th>
              <th rowspan="1" colspan="3">개선후 위험도</th>
              <th rowspan="2">개선결과</th>
            </tr>
          </template>
        </tr>
        <tr>
          <template v-if="isDKRAS">
            <th>발생빈도</th>
            <th>위험강도</th>
            <th>단위위험</th>
            <th>발생빈도</th>
            <th>위험강도</th>
            <th>단위위험</th>
            <th>1차</th>
            <th>2차</th>
          </template>
          <template v-else>
            <th>발생빈도</th>
            <th>위험강도</th>
            <th>단위위험</th>
            <th>1차</th>
            <th>2차</th>
            <th>발생빈도</th>
            <th>위험강도</th>
            <th>단위위험</th>
          </template>
        </tr>
      </template>
      </thead>
      <tbody>
      <!--      개정전-->
      <template v-if="!isRevision">
        <tr v-for="(row, rowIndex) in value" :key="`tableValue_${rowIndex}`">
          <template v-if="isDKRAS">
            <td>{{row.분류}}</td>
            <td>{{row.원인}}</td>
            <td>{{row.위험요인}}</td>
            <td>{{row.현재조치관리상태}}</td>
            <td>{{row.발생빈도}}</td>
            <td>{{row.위험강도}}</td>
            <td>{{row.단위위험}}({{row.위험도}})</td>
            <td>{{row.감소대책}}</td>
            <td>{{row.담당자}}</td>
            <td>{{row.완료예정일}}</td>
            <td>{{row.검토1차}}</td>
            <td>{{row.검토2차}}</td>
          </template>
          <template v-else>
            <td>{{row.작업단계}}</td>
            <td>
              <img v-if="row.작업사진 && row.작업사진.path" :src="row.작업사진.path" alt="작업사진" style="width: 100px;">
            </td>
            <td>{{row.위험요인}}</td>
            <td>{{row.현재관리상태}}</td>
            <td>{{row.발생빈도}}</td>
            <td>{{row.위험강도}}</td>
            <td>{{row.단위위험}}({{row.위험도}})</td>
            <td>{{row.감소대책}}</td>
            <td>{{row.담당자}}</td>
            <td>{{row.완료예정일}}</td>
            <td>{{row.검토1차}}</td>
            <td>{{row.검토2차}}</td>
            <td>{{row.비고}}</td>
          </template>
        </tr>
      </template>
      <!--      개정후-->
      <template v-else>
        <tr v-for="(row, rowIndex) in value" :key="`tableValue_${rowIndex}`">
          <template v-if="isDKRAS">
            <td>{{row.분류}}</td>
            <td>{{row.원인}}</td>
            <td>{{row.위험요인}}</td>
            <td>{{row.현재조치관리상태}}</td>
            <td>{{row.발생빈도}}</td>
            <td>{{row.위험강도}}</td>
            <td>{{row.단위위험}}({{row.위험도}})</td>
            <td>{{row.감소대책}}</td>

            <td>{{row.개선후_발생빈도}}</td>
            <td>{{row.개선후_위험강도}}</td>
            <td>{{row.개선후_단위위험}}({{row.개선후_위험도}})</td>
            <td>{{row.개선결과}}</td>

            <td>{{row.담당자}}</td>
            <td>{{row.완료예정일}}</td>
            <td>{{row.검토1차}}</td>
            <td>{{row.검토2차}}</td>
          </template>
          <template v-else>
            <td>{{row.작업단계}}</td>
            <td>
              <img v-if="row.작업사진 && row.작업사진.path" :src="row.작업사진.path" alt="작업사진" style="width: 100px;">
            </td>
            <td>{{row.위험요인}}</td>
            <td>{{row.현재관리상태}}</td>
            <td>{{row.발생빈도}}</td>
            <td>{{row.위험강도}}</td>
            <td>{{row.단위위험}}({{row.위험도}})</td>
            <td>{{row.감소대책}}</td>
            <td>{{row.담당자}}</td>
            <td>{{row.완료예정일}}</td>
            <td>{{row.검토1차}}</td>
            <td>{{row.검토2차}}</td>
            <td>{{row.비고}}</td>

            <td>{{row.개선후_발생빈도}}</td>
            <td>{{row.개선후_위험강도}}</td>
            <td>{{row.개선후_단위위험}}({{row.개선후_위험도}})</td>
            <td>{{row.개선결과}}</td>
          </template>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "PrintTable",
  props: {
    title: String,
    tableData: Array,
    value: Array,
    isRevision: Boolean,
    isDKRAS: Boolean,

    risk: String, // 위험성평가표.위험도
    importantRisk: String, // 위험성평가표.중요위험
  },
  computed: {
    rows: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
}
</script>
<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  th, td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
    text-align: center;
  }
  th {
    background-color: #F9F9F9;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;
  }
  td {
    background-color: #fff;
  }
}
</style>
